import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  /** Say what is searchable, e.g. "Name or code". */
  placeholder?: string;
  width?: CSSProperties['inlineSize'];
  disabled?: boolean;
  /** Providing this shows a clear affordance once there is a value. */
  onClear?: () => void;
  style?: CSSProperties;
}

/** Search field for list filtering. */
export function SearchInput({
  value,
  onChange,
  placeholder,
  width = 'var(--fs-search-width)',
  disabled,
  onClear,
  style,
}: SearchInputProps) {
  const { t } = useTranslation();
  const classes = ['fs-control'];
  if (disabled) classes.push('fs-control--disabled');
  return (
    <span className={classes.join(' ')} style={{ inlineSize: width, ...style }}>
      <input
        type="search"
        className="fs-control__input"
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        aria-label={placeholder ?? t('common.search')}
        onChange={(event) => onChange(event.target.value)}
      />
      {value && onClear && (
        <button type="button" className="fs-control__clear" onClick={onClear} aria-label={t('common.clearSearch')}>
          <span aria-hidden="true">×</span>
        </button>
      )}
    </span>
  );
}
